import React from 'react'
import IMG from "../../assets/Elsevier.png"
import "./styles.css"
const data=[
    {
        id:1,
        avatar:IMG,
        title:"Ensemble Learning Approach for Short-term Energy Consumption Prediction",
        authors: 'Sujan Reddy A, Akashdeep S, Harshvardhan R, Sowmya Kamath S',
        details: [
          "Ensemble learning based approaches for short-term electricity consumption on an open dataset.",
          "Experimented with machine learning and deep models like Random Forests, Long Short Term Memory, Deep Neural Networks, and Evolutionary Trees as the base models.", 
          "Based on the experimental observations, two different ensemble models are proposed, where the predictions of the base models are combined using Gradient Boosting and Extreme Gradient Boosting (XGB)"
        ],
        conference: [
          {
            name:"Advanced Engineering Informatics",
            link:"https://doi.org/10.1016/j.aei.2022.101542"
          },
          {
            name:"YRS CODS-COMAD 2022",
            link:"https://dl.acm.org/doi/abs/10.1145/3493700.3493743"
          },
          
        ]
    }
]
const Publications = () => {
    return (
      <section id="publications">
          
        <h2>Publication</h2>
        <div className="container publications__container">
        {
              data.map(({avatar,title,authors,details,conference})=>{
                return (
                  
                    <article className="publication">
                      <div className="publication__avatar">
                          <img src={avatar} alt="" />
                      </div>

                      <div className="publication__metadata">
                        <h3 className='publication__name'>{title}</h3>
                        <h4 >{authors}</h4>
                        <div>
                          Full paper at 
                          <a href={conference[0].link}> {conference[0].name} </a> 
                          and extended abstract at 
                          <a href={conference[1].link}> {conference[1].name} </a> 
                        </div>
                      </div> 

                      
                      <div className="publication__review">
                      <ul>
                        {
                          details.map((val)=>{
                            return(
                                <li className='publication__list-item'>&#8226; {val}</li>
                            )
                          })
                        }
                      </ul>
                      </div>
                    </article>
            
                )
              })
          }
          
        </div>
      </section>
    )
  }
  
  export default Publications